import { Card, Grid2, Paper, Typography } from "@mui/material";
import MobileView from "./MobileView";
import StandardView from "./StandardView";
import { useContext } from "react";
import { AppContext } from "../context/AppContext";
import ocLogoIcon from "../assets/img/oclogo.png";

export default function AgentMessageCard(props: { mobileView?: boolean }) {
	const { appState } = useContext(AppContext);
	const { info, colorPallete } = appState;
	return (
		<Grid2 container spacing={1.5} sx={{ flexGrow: 1 }}>
			<Grid2 size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }} display={"flex"}>
				<Card
					className="fullwidth-container"
					sx={{
						padding: 1,
						backgroundColor: colorPallete["scheme2"],
						textAlign: "left",
					}}
				>
					<Typography variant="h5" mb={1.5} sx={{ fontSize: "24px", fontWeight: 500 }}>
						Hi {info?.client?.name?.trim()} 👋
					</Typography>
					<Typography variant="body1" sx={{ fontSize: "16px", fontWeight: 500, lineHeight: "24px" }}>
						{info?.agent?.messageToClient}
					</Typography>
					<br />
					<Typography variant="body1" pl={1}>
						- {info?.agent?.signature}
					</Typography>
				</Card>
			</Grid2>
			{info.agent?.displayOCLogo && (
				<Grid2
					size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}
					display={{ xs: "none", md: "flex", lg: "flex", xl: "flex" }}
				>
					<Card component={Paper} sx={{ alignContent: "center", flexGrow: 1 }}>
						{info.agent?.customOCLogo ? (
							<img
								src={info.agent.customOCLogo}
								alt="OC Logo"
								style={{
									width: "100%",
									height: "auto",
									maxHeight: "100px",
									maxWidth: "92px",
									zoom: 2.5,
								}}
							/>
						) : (
							<a href="https://www.ownerconsole.com" target="_blank" rel="noreferrer">
								<img
									src={ocLogoIcon}
									alt="OC Logo"
									style={{
										width: "100%",
										height: "auto",
										maxHeight: "290px",
										maxWidth: "92px",
										zoom: 2.5,
									}}
								/>
							</a>
						)}
					</Card>
				</Grid2>
			)}
		</Grid2>
	);
	// if (props.mobileView) {
	// 	return <MobileView>{content}</MobileView>;
	// }
	// return <StandardView> {content}</StandardView>;
}
